import { render, staticRenderFns } from "./BrandAlbumLog.vue?vue&type=template&id=78bc9278"
import script from "./BrandAlbumLog.vue?vue&type=script&lang=ts"
export * from "./BrandAlbumLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports